import React from "react";
import { Link } from "react-router-dom";
import "./TextLink.css";

class TextLink extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isHovered: false,
    };

    this.handleOnHover = this.handleOnHover.bind(this);
    this.handleOnPointerLeave = this.handleOnPointerLeave.bind(this);
  }

  handleOnHover() {
    this.setState({
      isHovered: true,
    });
  }

  handleOnPointerLeave() {
    this.setState({
      isHovered: false,
    });
  }

  render() {
    return (
      <span
        className="link-container"
        onPointerOver={this.handleOnHover}
        onPointerLeave={this.handleOnPointerLeave}
      >
        <Link
          to={this.props.to}
          href={this.props.href}
          className="links"
          onClick={this.props.handleOnClick}
        >
          {this.props.text}
        </Link>
        <div className="hover-bar-container">
          <span
            className={this.state.isHovered ? "hover-bar hovered" : "hover-bar"}
          ></span>
        </div>
      </span>
    );
  }
}

export default TextLink;
